export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/emotes_badges.c645e39.svg";